import gql from 'graphql-tag';

import userGroupFragment from './user-group-fragment';

export default gql`
  query findOneUserGroupQuery($filter: FilterFindOneUserGroupInput) {
    findOneUserGroupQuery(filter: $filter) {
      ...UserGroupFragment
    }
  }
  ${userGroupFragment}
`;
